import type { ButtonHTMLAttributes } from 'react';

export type ButtonTone = 'pink' | 'cyan' | 'yellow' | 'green' | 'orange' | 'white';
type Variant = 'primary' | 'ghost' | 'card';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  tone?: ButtonTone;
}

const TONE_CLASSES: Record<ButtonTone, string> = {
  pink:   'border-[#ff3aa6] text-[#ff3aa6] hover:bg-[#ff3aa6]/10',
  cyan:   'border-[#3af0ff] text-[#3af0ff] hover:bg-[#3af0ff]/10',
  yellow: 'border-[#ffd23a] text-[#ffd23a] hover:bg-[#ffd23a]/10',
  green:  'border-[#3aff8e] text-[#3aff8e] hover:bg-[#3aff8e]/10',
  orange: 'border-[#ff8e3a] text-[#ff8e3a] hover:bg-[#ff8e3a]/10',
  white:  'border-white text-white hover:bg-white/10',
};

export function PixelButton({ variant = 'primary', tone, className = '', ...rest }: Props) {
  const base = 'pixel-text uppercase tracking-widest px-4 py-2 select-none transition-colors';
  let variantClass: string;
  if (variant === 'card') {
    const t = tone ?? 'pink';
    variantClass = `bg-ink-800 border-2 ${TONE_CLASSES[t]} active:translate-y-[2px]`;
  } else if (variant === 'primary') {
    variantClass = 'bg-neon-pink text-ink-900 border-2 border-ink-900 active:translate-y-[2px]';
  } else {
    variantClass = 'bg-transparent text-neon-cyan border-2 border-neon-cyan active:translate-y-[2px]';
  }
  return <button className={`${base} ${variantClass} ${className} disabled:opacity-40 disabled:cursor-not-allowed disabled:pointer-events-none`} {...rest} />;
}
